import { render, staticRenderFns } from "./client-detail.vue?vue&type=template&id=90fd7eca&scoped=true"
import script from "./client-detail.vue?vue&type=script&lang=js"
export * from "./client-detail.vue?vue&type=script&lang=js"
import style0 from "./client-detail.vue?vue&type=style&index=0&id=90fd7eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fd7eca",
  null
  
)

export default component.exports